module.exports = __webpack_public_path__ + "static/media/menu.b460b861.svg";